import { motion } from 'motion/react';
import { useEffect, useRef, useState } from 'react';
import './SplashScreen.css';

const SplashScreen = ({ onComplete }) => {
  const [phase, setPhase] = useState('in');
  const completedRef = useRef(false);

  const letters = ['A', 'D', 'E', 'E', 'F'];
  const letterAnimMs = 550;
  const letterStaggerMs = 550;
  const postHoldMs = 150;

  const completeSplash = () => {
    if (completedRef.current) return;
    completedRef.current = true;

    setPhase('out');
    window.setTimeout(() => {
      onComplete?.();
    }, 350);
  };

  useEffect(() => {
    const totalMs = (letters.length - 1) * letterStaggerMs + letterAnimMs + postHoldMs;
    const timer = window.setTimeout(completeSplash, totalMs);
    return () => window.clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <motion.div
      className="adeef-splash"
      initial={{ opacity: 1 }}
      animate={{ opacity: phase === 'out' ? 0 : 1 }}
      transition={{ duration: 0.35, ease: [0.83, 0, 0.17, 1] }}
      aria-label="Loading"
      role="status"
    >
      <div className="adeef-splash-inner">
        <div className="adeef-splash-letters" aria-hidden="true">
          {letters.map((letter, index) => (
            <span
              key={`${letter}-${index}`}
              className="adeef-splash-letter"
            >
              <span
                className="adeef-splash-letter-inner"
                style={{ animationDelay: `${index * letterStaggerMs}ms` }}
              >
                {letter}
              </span>
            </span>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default SplashScreen;
